import React from 'react';
import useResponsive from '../hooks/useResponsive';

const ResponsiveProfileSection = ({ 
  profileImage, 
  profileData = [], 
  className = '' 
}) => {
  const { isMobile, isTablet } = useResponsive();

  const getImageSize = () => {
    if (isMobile) return '80px';
    if (isTablet) return '100px';
    return '120px';
  };

  const getContainerStyle = () => {
    return {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'center' : 'flex-start',
      gap: isMobile ? '20px' : '30px',
      padding: '20px',
      width: '100%',
      maxWidth: '100%'
    };
  };

  const getImageContainerStyle = () => {
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0
    };
  };

  const getDataContainerStyle = () => {
    return {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      flexWrap: 'wrap',
      gap: isMobile ? '15px' : '20px',
      flex: 1,
      width: '100%'
    };
  };

  const getSectionStyle = () => {
    return {
      flex: isMobile ? '1 1 100%' : '1 1 300px',
      minWidth: isMobile ? '100%' : '250px'
    };
  };

  const getItemStyle = () => {
    return {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '5px' : '10px',
      marginBottom: '8px',
      padding: '5px 0',
      borderBottom: '1px solid #f0f0f0'
    };
  };

  const getLabelStyle = () => {
    return {
      fontWeight: '600',
      color: '#333',
      fontSize: isMobile ? '14px' : '15px',
      minWidth: isMobile ? 'auto' : '120px'
    };
  };

  const getValueStyle = () => {
    return {
      color: '#666',
      fontSize: isMobile ? '14px' : '15px',
      flex: 1
    };
  };

  return (
    <div className={`responsive-profile-section ${className}`} style={getContainerStyle()}>
      {/* Profile Image */}
      <div style={getImageContainerStyle()}>
        <img
          src={profileImage}
          alt="Profile"
          style={{
            width: getImageSize(),
            height: getImageSize(),
            borderRadius: '50%',
            objectFit: 'cover',
            border: '2px solid #e0e0e0'
          }}
        />
      </div>

      {/* Profile Data */}
      <div style={getDataContainerStyle()}>
        {profileData.map((section, sectionIndex) => (
          <div key={sectionIndex} style={getSectionStyle()}>
            {section.map((item, itemIndex) => (
              <div key={itemIndex} style={getItemStyle()}>
                <span style={getLabelStyle()}>{item.label}:</span>
                <span style={getValueStyle()}>{item.value || "---"}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResponsiveProfileSection;

